<template>
    <!--    eslint-disable-->
    <div class="claim-view-page">
        <div class="page-header">
            <h4>
                {{ pageTitle }}
                <span class="autosave">{{ autoSaveMessage }}</span>
            </h4>
            <ol class="breadcrumbs">
                <li class="breadcrumb-item home">
                    <router-link to="/dashboard">Home</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="'/claims'">View Claims</router-link>
                </li>
                <li class="breadcrumb-item active">
                    <span class="d-none d-lg-inline-block">Claim Details</span>
                </li>
            </ol>

            <b-dropdown class="dropdown-options dropdown-options--icon-only" right>
                <template v-slot:button-content>
                    <span class="dropdown-arrow">
                        <i class='bx bxs-chevron-down'></i>
                    </span>
                </template>

                <b-dropdown-item v-show="showLicenseRequest" @click="openLicenseDetailsForm">Send License Request</b-dropdown-item>
                <b-dropdown-item v-show="showPaymentRequest" @click="openCreditCardForm">Send Payment Verify</b-dropdown-item>
                <b-dropdown-item v-show="showRentalAgreementOption" @click="openRentalAgreementPdf">Get Rental Agreement PDF</b-dropdown-item>
                <b-dropdown-item @click="addNote">Add Note</b-dropdown-item>
                <b-dropdown-item v-show="showCreateAssessmentOnInsured" @click="sendRepairerNotice(false)">Send Repairer Notice</b-dropdown-item>
                <b-dropdown-item v-show="showCreateAssessmentOnOtherParty" @click="sendRepairerNotice(activeOtherParty.id)">Send Repairer Notice</b-dropdown-item>

                <b-dropdown-item v-show="showViewSettlementsSummary" @click="viewSettlementSummary">View Stlmnt Summary</b-dropdown-item>

                <b-dropdown-item @click="clickOnForDelete">Delete Claim</b-dropdown-item>
                <b-dropdown-item v-show="showCreateAssessmentOnInsured && !assessmentExists" @click="createAssessmentOnIsured">Create Assessment</b-dropdown-item>
                <b-dropdown-item v-show="showCreateAssessmentOnInsured && assessmentExists" @click="goToAssessment">Go to Assessment</b-dropdown-item>
                <b-dropdown-item v-show="showCreateAssessmentOnOtherParty && assessmentExists" @click="goToAssessment">Go to Assessment</b-dropdown-item>
                <b-dropdown-item v-show="showCreateAssessmentOnOtherParty && !assessmentExists" @click="createAssessmentOnOtherParty(activeOtherParty.id)">
                    Create Assessment
                </b-dropdown-item>
                <b-dropdown-item v-show="false && (showCreateAssessment &&  assessmentExists)" @click="deleteAssessment">Delete Assessment</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="claim-view-body">
            <tabs :options="{ useUrlFragment: false }" @changed="changedTab" ref="claim-view-tabs">
                <tab name="Insured"
                     id="claim-view-insured"
                     :class-name="'tab-content-table'">
                    <claim-view-insured-tab
                            :claim="claim"
                            :insured="insured"
                            :assessment="insuredAssessment"
                            :statuses-list="statusesList"
                            :current-status="currentStatus"
                            :owners="customersList"
                            :rentals="rentals"
                            :referrers="referrers"
                            :repairers="repairers"
                            :estimators="estimators"
                            @on-step-changed="onStepChanged"
                            @on-claim-types-changed="onTypesChanged"
                            @on-add-new-insured="addNewInsured"
                            @on-select-another-insured="selectAnotherInsured"
                            @on-rename-current-insured="renameCurrentInsured"
                            @on-click-go-to-full-activity="clickGoToActivityTab"
                            :on-referrer-changed="onInsuredReferrerSelect"
                            @on-insured-repairer-updated="onRepairerUpdate"
                            @with-recoveries-on-changed="withRecoveriesOnChanged"
                            @saveSignature="saveSignature"
                    >
                    </claim-view-insured-tab>
                </tab>
                <tab name="Other Party"
                     id="claim-view-other-party"
                     :class-name="'tab-content-table'">
                    <claim-view-other-party-tab
                            :otherParties="otherParties"
                            :rentals="rentals"
                            :propsChangedOtherPartyTab="changedOtherPatryTab"
                            :assessments="otherPartyAssessments"
                            :claim="claim"
                            :statuses-list="statusesList"
                            :current-status="currentStatus"
                            :repairers="repairers"
                            :referrers="referrers"
                            :estimators="estimators"
                            @on-claim-types-changed="onTypesChanged"
                            @on-step-changed="onStepChanged"
                            @on-click-go-to-full-activity="clickGoToActivityTab"
                            @on-other-party-repairer-updated="onRepairerUpdate"
                            :on-referrer-changed="onOtherPartyReferrerSelect"
                            @saveSignature="saveSignature"
                    >

                    </claim-view-other-party-tab>
                </tab>
                <tab name="Rental"
                     id="claim-view-rental"
                     :class-name="'tab-content-table'">
                    <claim-view-rental-tab
                            :legal-firms="legalFirms"
                            :rentals="rentals"
                            :insured="insured"
                            :propsChangedRentalTab="changedRentalTab"
                            :otherParties="otherParties"
                            :rentals-to-remove="rentalsToRemove"
                            @rentalTotalChanged="rentalTotalChanged"
                    >

                    </claim-view-rental-tab>
                </tab>
                <tab name="Images"
                     :counter="imageList.length"
                     id="claim-view-images"
                     :class-name="'tab-content-table'">
                    <images-tab :imageList="imageList" @imageUploaded="loadImages" @changeImageCategory="changeImageCategory">

                    </images-tab>
                </tab>
                <tab name="Files"
                     id="claim-view-files"
                     :counter="filesList.length"
                     :class-name="'tab-content-table'">

                    <files-tab
                            :files-list="filesList"
                            :claim-id="$route.params.claimId"
                            @fileUploaded="loadFiles"
                            @changeFile="changeFile"
                    />

                </tab>
                <tab name="Notes"
                     :counter="notes.length"
                     id="claim-view-notes"
                     :class-name="'tab-content-table'">

                    <notes
                            :notes="notes"
                            :search="notesSearch"
                            :add-note-trigger="addNoteTrigger"
                            :claim-id="claim.id"
                            @loadNotes="loadNotes"
                    ></notes>

                </tab>
                <tab name="Activity"
                     ref="activity-tab"
                     id="claim-view-activity"
                     :class-name="'tab-content-table'">
                    <claim-view-activity-tab
                            ref="claim-view-activity-tab"
                            :statuses-list="statusesList"
                            :current-status="currentStatus"
                            :claim="claim"
                            @on-step-changed="onStepChanged"
                            @on-claim-types-changed="onTypesChanged"
                            @loadImages="loadImages"
                            @loadFiles="loadFiles"
                    />
                </tab>
                <template slot="nav-item-right">
                    <!-- pin image -->
                    <div class="tabs-nav-right-pin-images">
                        <label class="form-check-inline checkbox">
                            <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
                            <span class="icon"><i class='bx bx-check'></i></span>
                            <span class="text">Pin Images</span>
                        </label>
                    </div>

                    <div v-show="activeTab == 'Notes'" class="tabs-nav-right-search">
                        <b-form-input v-model="notesSearch" type="text" class="search-input" placeholder="Search for Notes"
                                      debounce="100"></b-form-input>
                    </div>

                    <!-- mobile options -->
                    <div class="ml-4">
                        <b-dropdown class="dropdown-options dropdown-options--icon-only" right dropleft no-caret>
                            <template v-slot:button-content>
                                <span class="dropdown-arrow">
                                    <i class='bx bxs-chevron-down'></i>
                                </span>
                            </template>

                            <b-dropdown-item v-show="showLicenseRequest" @click="openLicenseDetailsForm">Send License Request</b-dropdown-item>
                            <b-dropdown-item v-show="showPaymentRequest" @click="openCreditCardForm">Send Payment Verify</b-dropdown-item>
                            <b-dropdown-item v-show="showRentalAgreementOption" @click="openRentalAgreementPdf">Get Rental Agreement PDF</b-dropdown-item>
                            <b-dropdown-item @click="addNote">Add Note</b-dropdown-item>

                            <b-dropdown-item v-show="showViewSettlementsSummary" @click="viewSettlementSummary">View Stlmnt Summary</b-dropdown-item>

                            <b-dropdown-item @click="clickOnForDelete">Delete Claim</b-dropdown-item>

                            <b-dropdown-item v-show="showCreateAssessmentOnInsured && !assessmentExists" @click="createAssessmentOnIsured">Create Assessment</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnInsured && assessmentExists" @click="goToAssessment">Go to Assessment</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnOtherParty && assessmentExists" @click="goToAssessment">Go to Assessment</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnOtherParty && !assessmentExists" @click="createAssessmentOnOtherParty(activeOtherParty.id)">
                                Create Assessment
                            </b-dropdown-item>
                            <b-dropdown-item v-show="false && (showCreateAssessment &&  assessmentExists)" @click="deleteAssessment">Delete Assessment</b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <div class="tabs-nav-right-options ml-4">
                        <b-dropdown id="repairer-supplier-view-options" text="Options" class="dropdown-options">
                            <template v-slot:button-content>
                                Options
                                <span class="dropdown-arrow">
                                    <i class='bx bxs-chevron-down'></i>
                                </span>
                            </template>

                            <b-dropdown-item v-show="showLicenseRequest" @click="openLicenseDetailsForm">Send License Request</b-dropdown-item>
                            <b-dropdown-item v-show="showPaymentRequest" @click="openCreditCardForm">Send Payment Verify</b-dropdown-item>
                            <b-dropdown-item v-show="showRentalAgreementOption" @click="openRentalAgreementPdf">Get Rental Agreement PDF</b-dropdown-item>
                            <b-dropdown-item @click="addNote">Add Note</b-dropdown-item>
                            <b-dropdown-item @click="createTask">Add Task</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnInsured" @click="sendRepairerNotice(false)">Send Repairer Notice</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnOtherParty" @click="sendRepairerNotice(activeOtherParty.id)">Send Repairer Notice</b-dropdown-item>

                            <b-dropdown-item v-show="showViewSettlementsSummary" @click="viewSettlementSummary">View Stlmnt Summary</b-dropdown-item>

                            <b-dropdown-item @click="clickOnForDelete">Delete Claim</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnInsured && !assessmentExists" @click="createAssessmentOnIsured">Create Assessment</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnInsured && assessmentExists" @click="goToAssessment">Go to Assessment</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnOtherParty && assessmentExists" @click="goToAssessment">Go to Assessment</b-dropdown-item>
                            <b-dropdown-item v-show="showCreateAssessmentOnOtherParty && !assessmentExists" @click="createAssessmentOnOtherParty(activeOtherParty.id)">
                                Create Assessment
                            </b-dropdown-item>
                            <b-dropdown-item v-show="false && (showCreateAssessment &&  assessmentExists)" @click="deleteAssessment">Delete Assessment</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </template>
            </tabs>
        </div>

        <!-- pin image -->
        <transition name="slide-fade">
            <image-pin-area
                    v-if="pinImage"
                    :image-list="imageList"
                    @click-image="handleSelectPinImage"
                    @close="pinImage = false">
            </image-pin-area>
        </transition>

        <!-- image gallery -->
        <template v-if="showGallery">
            <image-gallery :use-editor="false"
                           :isDownload="true"
                           :isRemove="true"
                           :images="imageList"
                           :current-index="galleryCurrentIndex"
                           @remove-image="deleteImage"
                           @close-gallery="handleCloseGallery">
            </image-gallery>
        </template>
        <b-modal :centered="true" id="deleteClaimModal" ref="deleteClaimModal" aria-labelledby="deleteClaimModalLabel" header-class="modal-header-background" footer-bg-variant="light"
                 style="top: 10vh">
            <template v-slot:modal-header>
                <h4 class="modal-title" id="deleteClaimModalLabel">Delete Claim</h4>
                <button @click="$bvModal.hide('deleteClaimModal')" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style="color:#FFFFFF;">&times;</span>
                </button>
            </template>
            <template v-slot:default class="modal-body">
                <div v-if="dataDeleteClaim && dataDeleteClaim._status && dataDeleteClaim.canBeDeleted" class="form-group">
                    <p>The following claim and its linked items will be deleted</p>
                    <p></p>
                    <p><span class="font-nunito--bold">Claim Nbr:</span> {{dataDeleteClaim.claim.number}} </p>
                    <p v-for="dc_rental in dataDeleteClaim.rentals"><span class="font-nunito--bold">Rental Agmnt Nbr:</span> {{dc_rental.number}}</p>
                    <p v-for="dc_assessment in dataDeleteClaim.assessments"><span class="font-nunito--bold">Assessment Nbr:</span> {{dc_assessment.number}}</p>
                    <p v-for="dc_invoice in dataDeleteClaim.invoices"><span class="font-nunito--bold">Invoice Nbr:</span> {{dc_invoice.number}} </p>
                </div>
                <div v-if="dataDeleteClaim && dataDeleteClaim._status && dataDeleteClaim.canBeMarkedAsClosed" class="form-group">
                    <p>The following claim has been found to be linked with items not completely owned by {{ownerCompanyName}}. You will be able to Mark this Claim as Closed.</p>
                    <p></p>
                    <p><span class="font-nunito--bold">Claim Nbr:</span> {{dataDeleteClaim.claim.number}} </p>
                    <p v-for="dc_rental in dataDeleteClaim.rentals"><span class="font-nunito--bold">Rental Agmnt Nbr:</span> {{dc_rental.number}}</p>
                    <p v-for="dc_assessment in dataDeleteClaim.assessments"><span class="font-nunito--bold">Assessment Nbr:</span> {{dc_assessment.number}}
                        <span v-if="!dc_assessment.canBeDeleted" style="margin-left:35px;">Assigned to <span style="color:#EF8336;">{{dc_assessment.assigned.company}}</span></span>
                    </p>
                    <p v-for="dc_invoice in dataDeleteClaim.invoices"><span class="font-nunito--bold">Invoice Nbr:</span> {{dc_invoice.number}}
                        <span v-if="!dc_invoice.canBeDeleted" style="margin-left:35px;">Assigned to <span style="color:#EF8336;">{{dc_invoice.assigned.company}}</span></span>
                    </p>
                </div>
            </template>
            <template v-slot:modal-footer class="modal-footer">
                <button v-if="dataDeleteClaim && dataDeleteClaim._status && dataDeleteClaim.canBeDeleted" @click="deleteClaim" type="button" class="btn btn-primary" style="width:70px;">OK</button>
                <button v-if="dataDeleteClaim && dataDeleteClaim._status && dataDeleteClaim.canBeMarkedAsClosed" type="button" class="btn btn-primary" style="min-width:70px;" disabled="">Mark as
                    Closed
                </button>
                <button @click="$bvModal.hide('deleteClaimModal')" type="button" class="btn btn-secondary" data-dismiss="modal" style="width:70px;">Cancel</button>
            </template>
        </b-modal>

        <b-modal :centered="true" id="viewSettlementSummary" ref="viewSettlementSummary" aria-labelledby="viewSettlementSummaryLabel"
                 header-class="modal-header-background"
                 class="view-settlement-cost"
                 footer-bg-variant="light"
                 style="top: 11vh">
            <template v-slot:modal-header>
                <h4 class="modal-title" id="viewSettlementSummaryLabel">Settlement Summary</h4>
                <button @click="$bvModal.hide('viewSettlementSummary')" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style="color:#FFFFFF;">&times;</span>
                </button>
            </template>
            <template v-slot:default class="modal-body">

                <div class="mt-2 row">
                    <div class="col font-nunito--bold"><b>CLAIMED — TOTALS — <span style="white-space:nowrap;">{{computedSettledForCurrentTab.vehicleOwnerName}}</span> <span
                            style="white-space:nowrap;">({{computedSettledForCurrentTab.vehicleInsurerName}})</span></b></div>
                </div>

                <div class="mt-2 row">
                    <div class="col-8">Vehicle Repair</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.assessmentSubtotalApproved | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Vehicle Rental</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.rentalTotal | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Vehicle Rental - Tolls</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.rentalTollsSum | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Personal Injury</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.injuryTotalAmount | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Vehicle Repair Assessment</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.assessmentFeeTotalAmount | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Legal Fees</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.totalFees | formatMoney }}</div>
                </div>

                <div class="mt-4 row">
                    <div class="col-8 text-right "><b>Subtotal Cost</b></div>
                    <div class="col-4 mobile-text-right">{{ (computedSettledForCurrentTab.totalClaimed / 11 * 10) | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8 text-right "><b>GST</b></div>
                    <div class="col-4 mobile-text-right">{{ (computedSettledForCurrentTab.totalClaimed / 11) | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8 text-right "><b>Claimed GRAND TOTAL</b></div>
                    <div class="col-4 font-nunito--bold mobile-text-right">{{ (computedSettledForCurrentTab.totalClaimed) | formatMoney }}</div>
                </div>

                <div class="mt-8 row">
                    <div class="col font-nunito--bold"><b>CLAIM — EXPENSES</b></div>
                </div>

                <!--
                  <div class="mt-2 row">
                      <div class="col-8">Repair — Inline Smash Repair</div>
                      <div class="col-4 mobile-text-right">$100.00</div>
                  </div>
                  <div class="mt-2 row">
                      <div class="col-8">Rentals — 20 days @$30</div>
                      <div class="col-4 mobile-text-right">$1000.00</div>
                  </div>
                  -->

                <div class="mt-3 row">
                    <div class="col font-nunito--bold"><b>Vehicle Rental</b></div>
                </div>

                <div class="mt-2 row">
                    <div class="col-8">Vehicle Rental - Tolls</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.rentalTollsSum | formatMoney }}</div>
                </div>

                <div class="mt-2 row">
                    <div class="col-8">Vehicle Rental - Operational Cost</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.rentalOperationalCost | formatMoney }}</div>
                </div>

                <div class="mt-3 row">
                    <div class="col font-nunito--bold"><b>Additionals</b></div>
                </div>

                <div class="mt-2 row" v-for="(add,i) in computedSettledForCurrentTab.additionals" :key="i">
                    <div class="col-8">
                        <span v-if="add.type == 'service'">Service</span>
                        <span v-if="add.type == 'autobody_repair'">Service - Autobody Rpr</span>
                        <span v-if="add.type == 'product'">Product</span>
                        <template v-if="add.businessName != ''"> — {{ add.businessName }}</template>
                    </div>
                    <div class="col-4 mobile-text-right">{{ add.invoiceAmount | formatMoney }}</div>
                </div>

                <div v-if="computedSettledForCurrentTab.referrer" class="mt-2 row">
                    <div class="col-8">Referrer - Claim - {{computedSettledForCurrentTab.referrer.name}}</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.referrer.amount | formatMoney }}</div>
                </div>

                <div class="mt-3 row ">
                    <div class="col font-nunito--bold"><b>Assessment Fee</b></div>
                </div>

                <div class="mt-2 row">
                    <div class="col-8">Oracle Assessments</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.assessmentFeeTotalAmount | formatMoney }}</div>
                </div>

                <div class="mt-3 row">
                    <div class="col font-nunito--bold"><b>Legal Fees</b></div>
                </div>

                <div class="mt-2 row">
                    <div class="col-8">Rental Legal Fees</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.rentalLegalFees | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Repair Legal Fees</div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.repairLegalFees | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Personal Injury Legal Fees</div>
                    <div class="col-4 mobile-text-right ">{{ computedSettledForCurrentTab.injuryLegalFees | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8">Assessment Fee Legal Fees</div>
                    <div class="col-4 mobile-text-right ">{{ computedSettledForCurrentTab.assessmentFeeLegalFees | formatMoney }}</div>
                </div>

                <div class="mt-4 row">
                    <div class="col-8 text-right "><b>Subtotal Cost</b></div>
                    <div class="col-4 mobile-text-right">{{ (computedSettledForCurrentTab.expenseTotal / 11 * 10) | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8 text-right "><b>GST</b></div>
                    <div class="col-4 mobile-text-right">{{ (computedSettledForCurrentTab.expenseTotal / 11) | formatMoney }}</div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8 text-right "><b>Expense GRAND TOTAL</b></div>
                    <div class="col-4 mobile-text-right">{{ computedSettledForCurrentTab.expenseTotal | formatMoney }}</div>
                </div>
                <div class="mt-8 row">
                    <div class="col-8 text-right font-nunito--bold" style="padding-top:5px;"><b>Proposed Settlement Amt</b></div>
                    <div class="col-4 mobile-text-right proposed-sellt-amt">
                        <number-formatter
                                v-model="proposedSettlementAmount"
                                type="text"
                                class="font-nunito--bold  font-14 mobile-text-right form-control numeric"
                                format="$0,0.00"
                        ></number-formatter>
                    </div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8 text-right font-nunito--bold"><b>NET PROFIT</b></div>
                    <div class="col-4 font-nunito--bold font-14 mobile-text-right" :class="{
                        'text-danger': proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal <  0,
                        'theme-color': proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal >= 0,
                      }">
                        <b style="white-space:nowrap;">
                            <template v-if="proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal < 0">-</template>
                            <template v-else>+</template>
                            {{ Math.abs( proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal ) | formatMoney }}
                        </b>
                    </div>
                </div>
                <div class="mt-2 row">
                    <div class="col-8 text-right font-nunito--bold"><b>% Profit</b></div>
                    <div class="col-4 font-nunito--bold font-14 mobile-text-right" :class="{
                        'text-danger': proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal <  0,
                        'theme-color': proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal >= 0,
                      }">
                        <b style="white-space:nowrap;">
                            <template v-if="proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal < 0">-</template>
                            <template v-else>+</template>
                            <template v-if="computedSettledForCurrentTab.expenseTotal == 0">0%</template>
                            <template v-else>
                                {{ Math.abs( (proposedSettlementAmount - computedSettledForCurrentTab.expenseTotal) / computedSettledForCurrentTab.expenseTotal * 100 ).toFixed(2) }}%
                            </template>
                        </b>
                    </div>
                </div>

            </template>
            <template v-slot:modal-footer class="modal-footer">
                <button @click="$bvModal.hide('viewSettlementSummary')" type="button" class="btn btn-secondary" data-dismiss="modal" style="width:70px;">Close</button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    /* eslint-disable */

    import Axios from 'axios';
    import _ from "lodash";
    import ClaimViewInsuredTab from './claim-view/insured-tab';
    import ClaimViewAccidentTab from "./claim-view/accident-tab";
    import ClaimViewActivityTab from './claim-view/activity-tab';
    import imagePinArea from "../../components/image-pin-area";
    import imageGallery from "../../components/image-lightbox/image-gallery";
    import FileUpload from "../../components/FileUpload";
    import ClaimViewRentalTab from "./claim-view/rental-tab";
    import ClaimViewOtherPartyTab from "./claim-view/other-party-tab";
    import Notes from "./claim-view/notes";
    import FilesTab from "./claim-view/files-tab";
    import ImagesTab from "./claim-view/images-tab";
    import {mapGetters} from "vuex";
    import NumberFormatter from "@/components/number-formatter";

    export default {
        name: 'claim-view',
        components: {
            ClaimViewOtherPartyTab,
            ClaimViewRentalTab,
            ClaimViewAccidentTab,
            ClaimViewInsuredTab,
            imagePinArea,
            imageGallery,
            FileUpload,
            Notes,
            FilesTab,
            ImagesTab,
            ClaimViewActivityTab,
            NumberFormatter,
        },
        data: function () {
            return {
                proposedSettlementAmount: 0,
                companySettings: {
                    headingDefault: null,
                },
                dataDeleteClaim: {
                    canBeDeleted: false,
                    canBeMarkedAsClosed: false,
                    claim: {
                        number: '',
                        id: 0,
                    },
                    assessments: [],
                    rentals: [],
                    invoices: [],
                },
                activeRentalIdForLicense: 0,
                activeRentalIdForPayment: 0,
                activeRental: {},
                activeOtherParty: {},
                autoSaveUpdate: {},
                autoSaveMessage: '',
                isAutoSave: false,
                customersList: [],
                filesTableFields: [
                    {
                        label: 'File Name',
                        key: 'file_name',
                        sortable: true,
                        tdClass: 'file-name'
                    },
                    {
                        label: 'Date',
                        key: 'created_on',
                        sortable: true,
                        tdClass: 'uploaded-date'
                    },
                ],
                claim: {
                    id: 0,
                    number: '',
                    totalAmountSettled: 0,
                    manualQuoteTotal: null,
                    manualAssessedTotal: null,
                    manualInvoiceValue: null,
                },
                assessment: {
                    id: 0,
                    number: '',
                },
                insured: {
                    accident: {
                        details: {},
                        towing: {},
                    },
                    insurer: {
                        policyNumber: '',
                    },
                    rentalTotal: 0,
                    insured: {},
                    referrer: {
                        referrerId: 0,
                        name: '',
                        date: '',
                        amountToPay: '',
                        paidDate: '',
                    },
                    statement: {
                        confirmation: null,
                        signature: null,
                    }
                },
                rentals: [],
                otherParties: [],
                rentalsToRemove: [],
                imageList: [],
                filesList: [],
                // Pin Image and Gallery
                pinImage: false,
                galleryCurrentIndex: 0,
                showGallery: false,
                statusesList: [],
                currentStatus: 0,
                notes: [],
                addNoteTrigger: 0,
                activeTab: null,
                notesSearch: '',
                assessments: [],
                repairers: [],
                referrers: [],
                estimators: [],
                legalFirms: [],
            };
        },
        computed: {
            ...mapGetters({
                ownerCompanyName: 'currentCompany/getCompanyName',
                isNeedUpdateImages: "updater/isNeedUpdateImages",
                isNeedUpdateFiles: "updater/isNeedUpdateFiles",
            }),
            computedRentalForCurrentTab() {
                let find = null;
                if (this.activeTab == 'Insured') {
                    find = _.find(this.rentals, (r) => {
                        console.log('RFIns', r);
                        return (r.details && r.details.rentalAllocationRequired && r.details.hirerFrom && r.details.hirerFrom.id == 0);
                    });
                }
                if (this.activeTab == 'Other Party') {
                    find = _.find(this.rentals, (r) => {
                        console.log('RFOP', r);
                        return (r.details && r.details.rentalAllocationRequired && r.details.hirerFrom && r.details.hirerFrom.id == this.activeOtherParty.id);
                    });
                }
                console.log('RENTAL FOUND', find);
                return find;
            },
            showViewSettlementCountOption() {
                return [
                    'Insured',
                    'Other Party',
                    'Rental',
                ].indexOf(this.activeTab) > -1;
            },
            isClaimHeadingDefaultInsured() {
                return (this.companySettings && this.companySettings.headingDefault && this.companySettings.headingDefault == 'insured');
            },
            isClaimHeadingDefaultOtherParty() {
                return (this.companySettings && this.companySettings.headingDefault && this.companySettings.headingDefault == 'otherParty');
            },
            getAssessmentForInsured() {
                let assessment = null;
                this.assessments.forEach(a => {
                    if (Number(a.referenceId) == 0) {
                        assessment = a;
                    }
                });
                return assessment;
            },
            showRentalAgreementOption() {
                return this.activeTab == 'Rental' && this.activeRental.id;
            },
            insuredAssessment() {
                let assessment = null;
                this.assessments.forEach(a => {
                    if (a.referenceId == 0) {
                        assessment = a;
                    }
                });
                return assessment;
            },
            otherPartyAssessments() {
                let assessments = [];
                this.assessments.forEach(a => {
                    if (a.referenceId != 0) {
                        assessments.push(a);
                    }
                });
                return assessments;
            },
            pageTitle() {
                let title = 'Claim ';
                title += (!_.isEmpty(this.claim.number)) ? this.claim.number : ' ';
                if (this.isClaimHeadingDefaultOtherParty) {
                    title += ' | ';
                    title += (this.otherParties && this.otherParties[0] && this.otherParties[0].details && !_.isEmpty(this.otherParties[0].details.vehicleOwner)) ? this.otherParties[0].details.vehicleOwner : ' ';
                    title += ' | ';
                    title += (this.otherParties && this.otherParties[0] && this.otherParties[0].insurer && !_.isEmpty(this.otherParties[0].insurer.policyNumber)) ? this.otherParties[0].insurer.policyNumber : ' ';
                } else {
                    title += ' | ';
                    title += (this.insured && this.insured.insured && !_.isEmpty(this.insured.insured.name)) ? this.insured.insured.name : ' ';
                    title += ' | ';
                    title += (this.insured && this.insured.insurer && !_.isEmpty(this.insured.insurer.policyNumber)) ? this.insured.insurer.policyNumber : ' ';
                }
                return title;
            },
            showLicenseRequest() {
                this.activeRentalIdForLicense = 0;
                if (this.rentals.length == 0) {
                    return false;
                }
                let flag = false;
                let currentTabName = this.$refs['claim-view-tabs'].activeTabHash;
                if (currentTabName == '#claim-view-insured') {
                    this.rentals.forEach(r => {
                        if (!r.details.rentalAllocationRequired) {
                            return;
                        }
                        if (!r.details.hirerFrom) {
                            return;
                        }
                        if (r.details.hirerFrom.id == 0) {
                            flag = true;
                            this.activeRentalIdForLicense = r.id;
                        }
                    });
                    return flag;
                }

                if (currentTabName == '#claim-view-rental') {
                    if (!this.activeRental || !this.activeRental.details || !this.activeRental.details.rentalAllocationRequired || !this.activeRental.details.hirerFrom) {
                        return false;
                    }
                    this.activeRentalIdForLicense = this.activeRental.id;
                    return true;
                }

                if (currentTabName == '#claim-view-other-party') {
                    if (!this.activeOtherParty || !this.activeOtherParty.id) {
                        return false;
                    }
                    this.rentals.forEach(r => {
                        if (!r.details.rentalAllocationRequired || !r.details.hirerName || !r.details.hirerFrom || !r.details.hirerFrom.id) {
                            return;
                        }
                        if (this.activeOtherParty.id == r.details.hirerFrom.id) {
                            flag = true;
                            this.activeRentalIdForLicense = r.id;
                        }
                    });
                    return flag;
                }
            },
            showPaymentRequest() {
                this.activeRentalIdForPayment = 0;
                if (this.rentals.length == 0) {
                    return false;
                }
                let flag = false;
                let currentTabName = this.$refs['claim-view-tabs'].activeTabHash;
                if (currentTabName == '#claim-view-insured') {
                    this.rentals.forEach(r => {
                        if (!r.details.rentalAllocationRequired) {
                            return;
                        }
                        if (!r.details.hirerFrom) {
                            return;
                        }
                        if (r.details.hirerFrom.id == 0) {
                            flag = true;
                            this.activeRentalIdForPayment = r.id;
                        }
                    });
                    return flag;
                }

                if (currentTabName == '#claim-view-rental') {
                    if (!this.activeRental || !this.activeRental.details || !this.activeRental.details.rentalAllocationRequired || !this.activeRental.details.hirerFrom) {
                        return false;
                    }
                    this.activeRentalIdForPayment = this.activeRental.id;
                    return true;
                }

                if (currentTabName == '#claim-view-other-party') {
                    if (!this.activeOtherParty || !this.activeOtherParty.id) {
                        return false;
                    }
                    this.rentals.forEach(r => {
                        if (!r.details.rentalAllocationRequired || !r.details.hirerName || !r.details.hirerFrom || !r.details.hirerFrom.id) {
                            return;
                        }
                        if (this.activeOtherParty.id == r.details.hirerFrom.id) {
                            flag = true;
                            this.activeRentalIdForPayment = r.id;
                        }
                    });
                    return flag;
                }
            },
            showCreateAssessmentOnInsured() {
                return this.activeTab == 'Insured';
            },
            showCreateAssessmentOnOtherParty() {
                return this.activeTab == 'Other Party';
            },
            showViewSettlementsSummary() {
                return (this.activeTab == 'Insured' || this.activeTab == 'Other Party');
            },
            assessmentExists() {
                if (this.activeTab == 'Insured') {
                    return !!this.insuredAssessment;
                }
                if (this.activeTab == 'Other Party') {
                    return !!this.getAssessmentForOtherParty(this.activeOtherParty.id);
                }
            },
            showDeleteAssessment() {
                return (this.activeTab == 'Insured' || this.activeTab == 'Other Party')
                    && this.assessmentExists;
            },
            newAssessmentFor() {
                if (this.activeTab == 'Insured') {
                    return 0;
                }
                if (this.activeTab == 'Other Party') {
                    return this.activeOtherParty.id;
                }
                return null;
            },
            currentAssessmentId() {
                if (this.activeTab == 'Insured') {
                    return this.insuredAssessment ? this.insuredAssessment.id : null;
                }
                if (this.activeTab == 'Other Party') {
                    return this.getAssessmentForOtherParty(this.activeOtherParty.id) ? this.getAssessmentForOtherParty(this.activeOtherParty.id).id : null;
                }
                return null;
            },
            computedSettledForCurrentTab() {
                // this.proposedSettlementAmount = 0;
                let vm = this;
                const getReferrerName = function (referrerId) {
                    let r = _.find(vm.referrers, item => {
                        return Number(item.id) === Number(referrerId);
                    });
                    if (r){
                        return r.name;
                    }
                    return '';
                };
                let settled = null;
                if (this.activeTab == "Insured") {
                    settled = Object.assign({}, this.insured.insured.settled);
                    settled.rentalTotal = this.insured.rentalTotal;
                    settled.additionals = this.insured.insured.additionals;
                    settled.vehicleOwnerName = this.insured.insured?.vehicleOwner?.trim();
                    settled.vehicleInsurerName = this.insured.insurer?.insurerName?.trim();
                    settled.referrer = null;
                    if (this.insured?.referrer?.referrerId > 0) {
                        settled.referrer = {};
                        settled.referrer.name = getReferrerName(this.insured?.referrer?.referrerId);
                        settled.referrer.amount = this.insured?.referrer?.amountToPay;
                    }
                } else if (this.activeTab == "Other Party") {
                    settled = Object.assign({}, this.activeOtherParty.settled);
                    settled.rentalTotal = this.activeOtherParty.rentalTotal;
                    settled.additionals = this.activeOtherParty.additionals;
                    settled.vehicleOwnerName = this.activeOtherParty.details?.vehicleOwner?.trim();
                    settled.vehicleInsurerName = this.activeOtherParty.insurer?.insurerName?.trim();
                    if (this.activeOtherParty.referrer?.referrerId > 0) {
                        settled.referrer = {};
                        settled.referrer.name = getReferrerName(this.activeOtherParty.referrer?.referrerId);
                        settled.referrer.amount = this.activeOtherParty.referrer?.amountToPay;
                    }
                } else {
                    return null;
                }
                settled.assessmentInvoice = 0;
                if (this.currentAssessmentId) {
                    let a = null;
                    this.assessments.forEach(asm => {
                        if (asm.id == this.currentAssessmentId) {
                            a = asm;
                        }
                    });
                    settled.assessmentInvoice = a ? a.subtotal : 0;
                }

                settled.rental = this.computedRentalForCurrentTab;
                settled.rentalTollsSum = _.sumBy(settled.rental?.tolls || [], t => t.amount * 1);
                settled.rentalOperationalCost = (settled.rental?.details?.operationalCost || 0) * (settled.rental?.details?.countDaysOnHire || 0);

                settled.totalFees = parseFloat(settled.repairLegalFees || 0)
                    + parseFloat(settled.rentalLegalFees || 0)
                    + parseFloat(settled.injuryLegalFees || 0)
                    + parseFloat(settled.assessmentFeeLegalFees || 0);

                settled.totalSettled = parseFloat(settled.repairSettledAmount || 0)
                    + parseFloat(settled.rentalSettledAmount || 0)
                    + parseFloat(settled.injurySettledAmount || 0)
                    + parseFloat(settled.assessmentFeeSettledAmount || 0);

                settled.totalClaimed = parseFloat(settled.assessmentSubtotalApproved || 0)
                    + parseFloat(settled.rentalTotal || 0)
                    + parseFloat(settled.injuryTotalAmount || 0)
                    + parseFloat(settled.assessmentFeeTotalAmount || 0)
                    + parseFloat(settled.rentalTollsSum || 0)
                    + parseFloat(settled.totalFees || 0);

                settled.expenseTotal = parseFloat(settled.rentalLegalFees || 0)
                    + parseFloat(settled.repairLegalFees || 0)
                    + parseFloat(settled.injuryLegalFees || 0)
                    + parseFloat(settled.assessmentFeeLegalFees || 0)
                    + parseFloat(settled.rentalTollsSum || 0)
                    + parseFloat(settled.rentalOperationalCost || 0)
                    + parseFloat(settled.assessmentInvoice || 0)
                    + parseFloat(settled.referrer?.amount || 0);

                settled.additionals.forEach(a => {
                    settled.expenseTotal += parseFloat(a.invoiceAmount || 0);
                });

                return settled;
            }
        },
        filters: {},
        methods: {
            changeImageCategory(item) {
                if (!this.autoSaveUpdate.images) {
                    this.autoSaveUpdate.images = [];
                }
                this.autoSaveUpdate.images.push({id: item.id, newImageCategory: item.imageCategory});
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            changeFile(file) {
                if (!this.autoSaveUpdate.files) {
                    this.autoSaveUpdate.files = [];
                }
                this.autoSaveUpdate.files.push(file);
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            saveSignature(object) {
                //console.log('signature', object);
                this.autoSaveUpdate.newSignature = object;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            deleteImage(q, item) {
                if (!confirm(`Confirm you want to DELETE this photo`)) {
                    return;
                }
                Axios.post(`/ir/claim/${this.$route.params.claimId}/remove-file`, {fileId: item.id})
                    .then(response => {
                        if (response.data && response.data._status) {
                            let index = _.findIndex(this.imageList, el => Number(el.id) === Number(item.id));
                            console.log(index, item);
                            this.imageList.splice(index, 1);

                            this.$toast.success('Image removed!');
                            // this.$emit('fileUploaded');
                        } else {
                            this.$toast.error('Unable to remove image');
                        }
                    })
                    .catch(e => {
                        this.$toast.error('Unable to remove image');
                        console.error(e);
                    });
            },
            goToAssessment() {
                let id = this.currentAssessmentId;
                if (id > 0) {
                    this.$router.push({name: 'AssessmentView', params: {assessmentId: id}});
                }
            },
            deleteClaim() {
                let url = '/ir/claim/' + this.claim.id + '/delete';
                Axios.post(url)
                    .then(res => {
                        this.$refs.deleteClaimModal.hide();
                        if (res.data && res.data._status) {
                            this.$store.dispatch("claim/deleteClaimById", this.claim.id);
                            this.$store.dispatch("assessment/deleteAssessmentByClaimId", this.claim.id);
                            this.$toast.success("This Claim has been deleted");
                            this.$router.push('/claims');
                            return;
                        }
                        this.$toast.error("Something wrong. This Claim isn't deleted");
                    })
                    .catch(e => console.warn(e))
                    .finally(() => {
                    });

            },
            sendRepairerNotice(id = false) {
                if (id) {
                    this.$router.push(`/claims/${this.claim.id}/send-notice-to-repairer/${id}`);
                } else {
                    this.$router.push(`/claims/${this.claim.id}/send-notice-to-repairer`);
                }
            },
            viewSettlementSummary() {
                this.$bvModal.show('viewSettlementSummary');
            },
            clickOnForDelete() {
                let url = '/ir/claim/' + this.claim.id + '/for-delete';
                Axios.get(url)
                    .then(res => {
                        if (res.data && res.data._status) {
                            this.dataDeleteClaim = res.data;
                            this.$refs.deleteClaimModal.show();
                            return;
                        }
                        this.$toast.error('Some error with get claim data');
                    })
                    .catch(e => console.warn(e))
                    .finally(() => {
                    });
            },
            onReferrerChanged(val) {

            },
            clickGoToActivityTab() {
                let hash = this.$refs['activity-tab'].hash;
                this.$refs['claim-view-tabs'].selectTab(hash);
            },
            fileUploaded() {
                //  this.loadClaim(this.$route.params.claimId);
            },
            getAssessmentForOtherParty(opId) {
                let assessment = null;
                this.assessments.forEach(a => {
                    if (a.referenceId == opId) {
                        assessment = a;
                    }
                });
                return assessment;
            },
            rentalsUpdate(updates) {
                // console.log('startRentalUpdate')
                // console.log('updates',updates)
                let vm = this;
                this.isAutoSave = false;
                _.forEach(updates, (item) => {
                    let find = _.find(vm.rentals, function (o) {
                        return Number(o.id) === Number(item.id);
                    });
                    // console.log('find', find);
                    if (find) {
                        if (item.number) {
                            find.details.rentalAgreementNumber = item.number;
                        }
                        if (item.creditCardSentNotice) {
                            find.allocation.creditCardSentNotice = item.creditCardSentNotice;
                        }
                        if (item.dateCreditCardSentNotice) {
                            find.allocation.dateCreditCardSentNotice = item.dateCreditCardSentNotice;
                        }
                        if (item.licenseRequestSentNotice) {
                            find.allocation.licenseRequestSentNotice = item.licenseRequestSentNotice;
                        }
                        if (item.dateLicenseRequestSentNotice) {
                            find.allocation.dateLicenseRequestSentNotice = item.dateLicenseRequestSentNotice;
                        }
                        if (item.newToll) {
                            find.tolls.push(item.newToll);
                            find.addNewToll = false;
                        }
                        if (item.isNewLegalFirm && item.isNewLegalFirm._status) {
                            console.log('NEW LEGAL FIRM UPDATE', item, find);
                            find.newLegalFirm = false;
                            this.legalFirms.push({
                                id: item.isNewLegalFirm.legalFirmId,
                                name: item.isNewLegalFirm.legalFirmName,
                            });
                            find.recoveries.legalFirm = item.isNewLegalFirm.legalFirmId;
                        }
                        // find.tollsToDelete = [];
                    }
                });
                //console.log('finishRentalUpdate')
                this.isAutoSave = true;
            },
            addNote() {
                this.addNoteTrigger++;
            },
            createTask() {
                this.clickGoToActivityTab();
                this.$refs['claim-view-activity-tab'].showNewTaskForm();
            },
            createAssessmentOnIsured() {
                this.createAssessment(0);
            },
            createAssessmentOnOtherParty(id) {
                this.createAssessment(id);
            },
            createAssessment(objectId) {
                this.$router.push({name: 'AssessmentNew', params: {claimId: this.claim.id, objectId: objectId}});
                return;
                Axios.post('/ir/assessment/create', {
                    claimId: this.claim.id,
                    referenceId: this.newAssessmentFor,
                })
                    .then(response => {
                        if (response.data && response.data._status) {
                            this.$toast.success(`Assessment ${response.data.assessment.number} created`);
                            this.loadClaim(this.$route.params.claimId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            deleteAssessment() {
                if (!this.currentAssessmentId) {
                    return;
                }
                Axios.post('/ir/assessment/delete', {
                    claimId: this.claim.id,
                    assessmentId: this.currentAssessmentId,
                })
                    .then(response => {
                        if (response.data && response.data._status) {
                            this.$toast.success(`Assessment deleted`);
                            this.loadClaim(this.$route.params.claimId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            loadNotes() {
                Axios.get('/ir/claim/' + this.claim.id + '/notes')
                    .then(res => {
                        if (res.data && res.data._status) {
                            if (res.data.data) {
                                this.notes = res.data.data;
                            }
                        }
                    })
                    .catch(e => console.warn(e));
            },
            changedRentalTab(val) {
                //console.log('changedRantalTab');
                if (val && val.tab && val.tab.id) {
                    let index = val.tab.id;
                    this.activeRental = this.rentals[index];
                } else {
                    this.activeRental = this.rentals[0];
                }
            },
            changedOtherPatryTab(val) {
                //console.log('changedOtherPatryTab');
                if (val && val.tab && val.tab.id) {
                    let index = val.tab.id;
                    this.activeOtherParty = this.otherParties[index];
                } else {
                    this.activeOtherParty = this.otherParties[0];
                }
            },
            openLicenseDetailsForm() {
                Axios.post('/ir/get-license-details-link', {claimId: this.claim.id, rentalId: this.activeRentalIdForLicense})
                    .then(res => {
                        if (res.data && res.data._status) {
                            if (res.data.link) {
                                // window.open(res.data.link, '__blank');
                                this.$toast.success("Link has been sent by email");
                                // window.open(res.data.link, '__blank');
                            }
                            if (res.data.resultRentals) {
                                this.rentalsUpdate(res.data.resultRentals);
                            }
                        }
                    })
                    .catch(e => console.warn(e));
            },
            openCreditCardForm() {
                Axios.post('/ir/get-credit-card-link', {claimId: this.claim.id, rentalId: this.activeRentalIdForPayment})
                    .then(res => {
                        if (res.data && res.data._status) {
                            if (res.data.link) {
                                this.$toast.success("Link has been sent by email");
                                //window.open(res.data.link, '__blank');
                            }
                            if (res.data.resultRentals) {
                                this.rentalsUpdate(res.data.resultRentals);
                            }
                        }
                    })
                    .catch(e => console.warn(e));
            },
            openRentalAgreementPdf() {
                NProgress.start();
                Axios.post('/ir/claim/rental-agreement-link', {claimId: this.claim.id, rentalId: this.activeRental.id})
                    .then(res => {
                        if (res.data && res.data._status) {
                            if (res.data.link) {
                                window.open(res.data.link, '__blank');
                                return;
                            }
                        }
                        this.$toast.error('Cannot generate PDF file');
                    })
                    .catch(e => console.warn(e))
                    .finally(() => {
                        NProgress.done();
                    });
            },
            autoSave() {
                this.autoSaveMessage = 'Saving...';
                let updateData = Object.assign({}, this.autoSaveUpdate);
                this.autoSaveUpdate = {};
                return Axios({
                    method: 'post',
                    responseType: 'json',
                    headers: {'Autosave': true},
                    url: `/ir/claim/${this.$route.params.claimId}`,
                    validateStatus: function (status) {
                        return status < 500;
                    },
                    data: updateData
                })
                    .then(response => {
                        if (response && response.status === 200 && response.data && response.data._status) {
                            this.autoSaveMessage = 'Saved';
                            this.rentalsToRemove = [];
                            if (response.data.resultRentals) {
                                this.rentalsUpdate(response.data.resultRentals);
                            }
                            if (updateData.types) {
                                this.loadClaim(this.claim.id);
                            }
                            if (updateData.insured && updateData.insured.insured) {
                                let flag = false;
                                let newIndex = false;
                                updateData.insured.insured.additionals.forEach((add, i) => {
                                    if (add.id == 0) {
                                        flag = true;
                                        newIndex = i;
                                    }
                                });
                                if (flag) {
                                    this.loadClaim(this.claim.id, data => {
                                        data.insured.insured.additionals.forEach(addn => {
                                            let exists = false;
                                            this.insured.insured.additionals.forEach((add) => {
                                                if (exists) return;
                                                if (addn.id == add.id) {
                                                    exists = true;
                                                }
                                            });
                                            if (!exists) {
                                                this.insured.insured.additionals[newIndex].id = addn.id;
                                            }
                                        });
                                    });
                                }
                            }
                            if (updateData.otherParties && updateData.otherParties.length > 0) {
                                updateData.otherParties.forEach((op, opi) => {
                                    let flag = false;
                                    let newIndex = false;
                                    op.additionals.forEach((add, i) => {
                                        if (add.id == 0) {
                                            flag = true;
                                            newIndex = i;
                                        }
                                    });
                                    if (flag) {
                                        this.loadClaim(this.claim.id, data => {
                                            data.otherParties[opi].additionals.forEach(addn => {
                                                let exists = false;
                                                this.otherParties[opi].additionals.forEach((add) => {
                                                    if (exists) return;
                                                    if (addn.id == add.id) {
                                                        exists = true;
                                                    }
                                                });
                                                if (!exists) {
                                                    this.otherParties[opi].additionals[newIndex].id = addn.id;
                                                }
                                            });
                                        });
                                    }
                                });
                            }
                        } else {
                            this.autoSaveMessage = 'Unsaved Changes';
                        }
                    })
                    .catch(error => {
                        this.autoSaveMessage = 'Unsaved Changes';
                    });
            },
            showUnsavedChanges: function () {
                if (!this.isAutoSave) {
                    return;
                }
                this.autoSaveMessage = 'Unsaved Changes';
            },
            hideSavedChanges() {
                if (!this.isAutoSave) {
                    return;
                }
                this.autoSaveMessage = '';
            },
            beforeDebouncedAutoSave: function () {
                if (!this.isAutoSave) {
                    return;
                }
                this.debouncedAutoSave();
            },
            beforeDebouncedUnsavedChanges: function () {
                if (!this.isAutoSave) {
                    return;
                }
                this.debouncedUnsavedChanges();
            },
            onClickImage() {
            },
            changePositionByArrowKey: function (ref, event) {
                let el = this.$refs[ref];
                if (el) {
                    el.focus();
                }
            },
            changedTab: function (obj) {
                this.activeTab = obj.tab.name;
            },
            loadImages() {
                console.log('start load images');
                let id = this.$route.params.claimId;
                this.loadClaim(id, data => {
                    this.imageList = data.images;
                    this.$store.dispatch('updater/resetImages');
                });
            },
            loadFiles() {
                console.log('start load files');
                let id = this.$route.params.claimId;
                this.loadClaim(id, data => {
                    this.filesList = data.files;
                    this.$store.dispatch('updater/resetFiles');
                });
            },
            loadClaim: function (id, callbackToReturn = false) {
                NProgress.start();
                Axios.get('/ir/claim/' + id)
                    .then((response) => {
                        if (response.data && response.data._status) {
                            if (callbackToReturn) {
                                callbackToReturn(response.data);
                                return;
                            }
                            this.claim = response.data.claim;
                            this.assessment = response.data.assessment;
                            this.assessments = response.data.assessments;
                            this.estimators = response.data.estimators;
                            this.insured = response.data.insured;
                            //this.imageList = response.data.images.map((image, index) => {
                            //    image.id = index;
                            //    return image;
                            //});
                            this.imageList = response.data.images;
                            this.filesList = response.data.files;
                            this.rentals = response.data.rentals;
                            this.otherParties = response.data.otherParties;
                            this.statusesList = response.data.statusesList;
                            this.currentStatus = response.data.currentStatus;
                            this.referrers = response.data.referrers;
                            this.legalFirms = response.data.legalFirms;
                            this.companySettings = response.data.companySettings;
                            var vm = this;
                            setTimeout(function () {
                                vm.isAutoSave = true;
                            }, 500);
                            this.changedRentalTab();
                            this.changedOtherPatryTab();
                            this.loadNotes();
                        }
                    })
                    .catch((error) => {
                        console.log('error:', error);
                    })
                    .finally(() => {
                        NProgress.done();
                    });
                Axios.get('/ir/insured-list')
                    .then(response => {
                        if (response.data && response.data instanceof Array) {
                            this.customersList = response.data;
                        }
                    })
                    .catch(e => console.error(e));
            },
            onRepairerUpdate() {
                this.loadClaim(this.claim.id);
            },
            loadRepairers() {
                Axios.get('/ir/repairers')
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.repairers = response.data.data;
                        }
                    })
                    .catch(e => console.error(e))
                    .finally(() => {
                    });
            },
            handleCloseGallery() {
                this.showGallery = false;
            },
            handleSelectPinImage(index) {
                this.galleryCurrentIndex = index;
                this.showGallery = true;
            },
            onStepChanged(step) {
                this.autoSaveUpdate.currentStatusId = step.id;
                this.currentStatus = step.id;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            onTypesChanged(types) {
                this.autoSaveUpdate.types = types;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            withRecoveriesOnChanged(val) {
                if (!this.autoSaveUpdate.claim) {
                    this.autoSaveUpdate.claim = {};
                }
                this.autoSaveUpdate.claim.withRecoveriesOn = val;
                this.claim.withRecoveriesOn = val;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            rentalTotalChanged(obj) {
                if (obj && obj.objId > 0) {
                    let op = _.find(this.otherParties, function (op) {
                        return Number(op.id) === Number(obj.objId);
                    });
                    console.log('op', op);
                    if (op) {
                        op.rentalTotal = obj.total;
                    }
                } else {
                    this.insured.rentalTotal = obj.total;
                }
                console.log('rental', obj);
            },
            addNewInsured(data) {
                this.isAutoSave = false;
                this.insured.insured = {
                    name: data.name,
                    id: null,
                    ownerType: null,
                    abn: '',
                    contact: '',
                    email: '',
                    address: {
                        location: '',
                        levelUnitLot: '',
                        streetName: '',
                        suburb: '',
                        state: '',
                        postcode: '',
                        country: 'AU',
                    },
                };
                this.autoSaveUpdate.insured = {};
                this.autoSaveUpdate.insured.insured = this.insured.insured;
                this.autoSave()
                    .then(() => {
                        // console.log('COOL');
                        this.loadClaim(this.$route.params.claimId);
                    });
            },
            selectAnotherInsured(data) {
                console.log('Another Insured', data);
                let id = data.id;
                let newCustomer = _.find(this.customersList, function (i) {
                    return i.id == id;
                });
                if (newCustomer) {
                    this.insured.insured = newCustomer;
                    this.autoSaveUpdate.insured = {};
                    this.autoSaveUpdate.insured.insured = this.insured.insured;
                    this.autoSave()
                        .then(() => {
                            console.log('COOL2');
                            this.loadClaim(this.$route.params.claimId);
                        });
                }
            },
            renameCurrentInsured(data) {
                console.log('rename Insured', data);
                this.insured.insured.name = data.name;
                this.autoSaveUpdate.insured = {};
                this.autoSaveUpdate.insured.insured = this.insured.insured;
                this.autoSave()
                    .then(() => {
                        console.log('COOL3');
                        this.loadClaim(this.$route.params.claimId);
                    });
                return;
            },
            onInsuredReferrerSelect(r) {
                console.log('r', r);
                if (r && r.id) {
                    this.insured.referrer.referrerId = r.id;
                } else {
                    this.insured.referrer.referrerId = false;
                    this.insured.referrer.referrerName = r.name;
                    setTimeout(() => {
                        this.loadClaim(this.claim.id);
                    }, 1500);
                }
            },
            onOtherPartyReferrerSelect(r) {
                setTimeout(() => {
                    this.loadClaim(this.claim.id);
                }, 1500);
            },
        },
        created: function () {
            this.debouncedAutoSave = _.debounce(this.autoSave, 1000);
            this.debouncedSavedChanges = _.debounce(this.hideSavedChanges, 10000);
            this.debouncedUnsavedChanges = _.debounce(this.showUnsavedChanges, 50);
        },
        mounted: function () {
            this.loadClaim(this.$route.params.claimId);
            this.loadRepairers();
        },
        watch: {
            isNeedUpdateFiles(newVal) {
                if (newVal === true) {
                    this.loadFiles();
                }
            },
            isNeedUpdateImages(newVal) {
                if (newVal === true) {
                    this.loadImages();
                }
            },
            rentalsToRemove(newVal) {
                if (!this.isAutoSave) {
                    return;
                }
                if (newVal && newVal.length > 0) {
                    this.autoSaveUpdate.rentalsToRemove = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            rentals: {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    this.autoSaveUpdate.rentals = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            otherParties: {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    this.autoSaveUpdate.otherParties = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.accident': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.accident = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.insured': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (newVal.name != oldVal.name || newVal.name == '') {
                        //    this.insured.insured.id=null;
                        return;
                    }
                    //console.log('new=',newVal)
                    //console.log('old=',oldVal)
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.insured = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.vehicle': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.vehicle = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.repairer': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.repairer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.innerRepairer': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.innerRepairer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.insurer': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.insurer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.rental': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.rental = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.referrer': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    console.log('referrer', newVal);
                    this.autoSaveUpdate.insured.referrer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.estimator': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.estimator = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.statement.confirmation': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    console.log('insured.statement', newVal);
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    if (!this.autoSaveUpdate.insured.statement) {
                        this.autoSaveUpdate.insured.statement = {};
                    }
                    this.autoSaveUpdate.insured.statement.confirmation = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            claim: {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.claim) {
                        this.autoSaveUpdate.claim = {};
                    }
                    this.autoSaveUpdate.claim = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            assessments: {
                deep: true,
                handler(newVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.assessments) {
                        this.autoSaveUpdate.assessments = [];
                    }
                    this.autoSaveUpdate.assessments = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },

        },
    };
</script>

<style lang="scss">
    .part-list-quote-pricing-progress {
        min-width: 450px;
        padding-left: 0px !important;
    }

    .part-list-quote-pricing-progress .quote-pricing-progress .wizard__divider {
        display: none !important;
    }

    .multiselect--disabled {
        opacity: 1 !important;
    }

    .claim-view-page {
        .dropdown-menu {
            &__save-button {
                display: block;
                width: 80% !important;
                color: white !important;
                text-align: center;
                margin: 15px auto;
            }

            .theme-repairer &__save-button {
                background-color: var(--repairer-color) !important;
            }
        }
    }

    .claim-view-page .part-list .claim-received .table {
        width: 568px;
    }

    .claim-view-page .vehicle-details-block {
        width: 572px;
        margin-left: 15px;
        margin-top: 15px;
    }

    .claim-view-page .best-value {
        max-width: 217px;
        width: auto;
    }

    @media (min-width: 992px) {
        .best-value {
            width: 270px !important;
        }
        @media (min-width: 992px) {
            .part-list .table-width {
                // width: 866px;
            }
        }
    }

    @media screen and (max-width: 425px) {
        .V3 .claim-view-page .vehicle-details-block {
            width: 97%;
            padding-right: 15px;
        }
        .claim-view-page .part-list {
            margin-top: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
        .tab__button-group {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            padding: 10px 10px 0px;

            .tab__button {
                margin: 0px 0px 10px 0px !important;
                height: 80px;
                flex: 50%;
            }
        }
        .claim-view-page .part-list .claim-received .table {
            width: 100%;
        }
    }

    .V3 .claim-view-page .part-list-supplier {
        box-sizing: border-box;
    }

    /* price click effect */
    /*.V3 .claim-view-page .part-list .part-list-supplier:active,*/
    /*.V3 .claim-view-page .part-list-priced .part-list-supplier:focus {*/
    /*    background-color: rgba(46, 169, 255, 0.2);*/
    /*}*/
    .V3 .claim-view-page .part-list .part-list-supplier:active {
        background-color: rgba(46, 169, 255, 0.2);
    }

    /* price hover effect */
    .V3 .claim-view-page .part-list .part-list-supplier[role='cell']:hover {
        border: 2px solid rgba(46, 169, 255, 1);
        // background-color: rgba(46,169,255,0.083);
        cursor: pointer;
    }

    .V3 .claim-view-page .offer-checked {
        border: 0px;
        background-color: rgba(46, 169, 255, 0.1);
    }

    .claim-view-page .part-list {
        margin-top: 15px;
        margin-left: 15px;
    }

    .claim-view-page .part-list .table {
        width: 866px;
    }

    .claim-view-page .part-list th {
        padding-left: 15px;
        padding-right: 15px;
    }

    .claim-view-page .part-list td {
        padding-left: 15px;
        padding-right: 15px;
    }

    .claim-view-page .part-list th.part-list-part-name,
    .claim-view-page .part-list td.part-list-part-name {
        width: 560px;
    }

    .claim-view-page .part-list th.part-list-part-name,
    .claim-view-page .part-list th.part-list-number,
    .claim-view-page .part-list th.part-list-qty,
    .claim-view-page .part-list th.part-list-rrp {
        padding-top: 26px;
    }

    .claim-view-page .part-list th.part-list-part-name div,
    .claim-view-page .part-list th.part-list-qty div.div-qty,
    .claim-view-page .part-list th.part-list-rrp div.div-qty {
        float: left;
    }


    .claim-view-page .part-list th.part-list-part-name span,
    .claim-view-page .part-list th.part-list-qty span,
    .claim-view-page .part-list th.part-list-rrp span,
    .claim-view-page .part-list th.part-list-number span {
        background-image: url("data:image/svg+xml;base64,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");
        height: 16px;
        width: 8px;
        display: inline-block;
        cursor: pointer;
    }

    .claim-view-page .part-list th.part-list-part-name span {
        margin-left: 5px;
    }

    .claim-view-page .part-list th.part-list-qty span {
        margin-left: 5px;
    }

    .claim-view-page .part-list th.part-list-rrp span {
        margin-left: 5px;
    }

    .V3 .claim-view-page .part-list-qty,
    .V3 .claim-view-page .part-list-rrp,
    .V3 .claim-view-page .part-list[role='cell'] {
        min-width: 68px;
    }

    .claim-view-page .part-list th.part-list-qty,
    .claim-view-page .part-list td.part-list-qty,
    .claim-view-page .part-list th.part-list-rrp,
    .claim-view-page .part-list td.part-list-rrp {
        width: 70px;
    }

    .claim-view-page .part-list th.part-list-number,
    .claim-view-page .part-list td.part-list-number,
    .claim-view-page .part-list th.part-list-supplier,
    .claim-view-page .part-list td.part-list-supplier {
        width: 135px;
    }

    .claim-view-page .part-list td div.part-list-item-name {
        color: #1C1F39;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 16px;
    }

    .claim-view-page .part-list td div.part-list-item-number {
        color: #1C1F39;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
    }

    .claim-view-page .part-list td div.part-list-item-qty,
    .claim-view-page .part-list td div.part-list-item-rrp {
        color: #1C1F39;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
    }

    .claim-view-page .part-list .part-list-item-price {
        opacity: 0.5;
        color: #1C1F39;
    }

    .claim-view-page .part-list .part-list-item-price--priced {
        opacity: 1;
    }

    .claim-view-page .part-list .supplier-icon {
        font-size: 20px;
        margin-bottom: 5px;
    }

    .claim-view-page .part-list .supplier-icon img {
        max-height: 25px;
    }

    .claim-view-page .part-list .supplier-icon .bx {
        opacity: 0.5;
    }

    .claim-view-page .part-list .supplier-name {
        color: #1C1F39;
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
        height: 36px;
        margin-bottom: 10px;
    }

    .claim-view-page .part-list .supplier-type {
        color: #1C1F39;
        font-size: 12px;
        font-style: italic;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
        text-align: center;
    }

    .claim-view-page .part-list .table .subheader {
        opacity: 0.5;
        color: #1C1F39;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 25px;
        padding-right: 0px;
    }

    .claim-view-page .part-list .table .subheader {
        line-height: 25px !important;
    }

    .claim-view-page .part-list .table .subheader-p-c {
        text-align: left;
        padding-left: 150px; // 30px
        height: 42px;
        /*  border-right: 1px solid rgba(27, 30, 56, 0.1);*/

    }

    .claim-view-page .part-list .table .subheader-t {
        text-align: left;
        padding-left: 150px;
        height: 57px;

        position: relative;
    }

    .claim-view-page .part-list .table .p-c-value {
        color: #1C1F39;;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
    }

    .claim-view-page .part-list .table .totals-value {
        color: #1C1F39;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 19px;
    }

    .claim-view-page .part-list .subheader.parts-footer {
        opacity: 1;
        color: #1C1F39;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 25px;
        padding-left: 150px;
    }

    .claim-view-page .part-list .subheader span.subheader-border-right {
        border-right: 1px solid rgba(27, 30, 56, 0.2);
        width: 1px;
        float: right;
        height: 25px;
        margin-left: 30px;
    }

    .claim-view-page .part-list .btn.order {
        min-width: 78px;
    }

    .claim-view-page .part-list .btn-outline-primary.order {
        color: #00B050;
    }

    /* global */
    .part-list .table {
        width: auto;
    }

    .tab {
        &__button-group {
            margin-bottom: 30px;
        }

        &__button {
            margin-top: 0;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0px;
            }
        }
    }

    .form-control.is-link {
        color: #00B050;
    }
</style>

<style scoped>

    div.box {
        text-align: center;
    }

    div.box img {
        /*display: block;*/
        height: 9rem;
    }

    .img-box {
        position: relative;
        width: 100%;
        height: 250px;
    }

    .img-box a {
        display: inline-block;
        height: 250px;
    }

    .img-box a img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .delivery-required-time {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    @media screen and (min-width: 1200px) {
        .delivery-required-time {
            margin-top: 45px;
        }
    }
</style>

<style>
    #viewSettlementSummary {
        margin-top: 52px;
        padding-bottom: 52px;
    }
</style>

<style scoped>
    .proposed-sellt-amt {
        padding-left: 5px;
    }

    @media screen and (max-width: 425px) {
        .mobile-text-right {
            text-align: right;
        }

        .proposed-sellt-amt {
            padding-right: 5px;
            padding-left: 10px;
        }

        .col-8 {
            padding-right: 0px !important;
        }
    }

    .mt-6 {
        margin-top: 1.5rem;
    }

    .mt-8 {
        margin-top: 2rem;
    }

</style>
